<div class="table-container">
    <h1>Răspuns</h1>
    <br/>
    <table>
      <thead>
        <tr>
          <th>Crt</th>
          <th>Currency</th>
          <th>Amount</th>
          <th>Invoice ID</th>
          <th>Observatii</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>1</td>
          <td>{{ data.bt.curr }}</td>
          <td>{{ data.bt.amount }}</td>
          <td>{{ data.bt.invoice_id }}</td>
          <td>{{ data.bt.message }}</td>
        </tr>
      </tbody>
    </table>
    <br/>
    <div class="button-back-container">
      <button class="button-back" (click)="closeDialog()">Înapoi</button>
    </div>
  </div>
